import { faFileCertificate } from "@fortawesome/pro-duotone-svg-icons/faFileCertificate";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_SKILLS_LINK: Breadcrumb = {
  icon: faFileCertificate,
  name: "Skills",
  to: "/dashboard/skills",
};
